import { useState } from 'react'
import { Modal, Form, Input, Button, Typography, message, Row, Col } from 'antd'
import { MailOutlined, UserOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

interface RegistrationModalProps {
  open: boolean
  onClose: () => void
}

const RegistrationModal = ({ open, onClose }: RegistrationModalProps) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (values: { name: string; email: string }) => {
    setLoading(true)
    try {
      // Here you would normally send the data to your backend
      console.log('Registration data:', values)
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      message.success('Vielen Dank! Wir melden uns bei Ihnen, sobald wir live gehen.')
      form.resetFields()
      onClose()
    } catch (error) {
      message.error('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="90%"
      style={{ maxWidth: '800px', padding: 0 }}
      centered
    >
      <Row>
        {/* Left side - Image */}
        <Col xs={0} md={12}>
          <div style={{
            height: '500px',
            backgroundImage: 'url(/images/modern-office-team.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: '8px 0 0 8px'
          }} />
        </Col>
        
        {/* Right side - Form */}
        <Col xs={24} md={12}>
          <div style={{ padding: '32px 24px' }}>
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <Title level={2} style={{ 
                color: '#1a202c', 
                marginBottom: '16px',
                fontSize: '28px'
              }}>
                ShiftedTime ist zurzeit in der Closed Beta
              </Title>
              
              <Text style={{ 
                color: '#64748b', 
                fontSize: '16px',
                lineHeight: '1.6',
                display: 'block'
              }}>
                Wir gehen in Kürze an den Markt.<br />
                Sei der erste, der darüber Bescheid weiß!
              </Text>
            </div>

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              size="large"
            >
              <Form.Item
                name="name"
                label="Dein Name"
                rules={[
                  { required: true, message: 'Bitte geben Sie Ihren Namen ein' },
                  { min: 2, message: 'Name muss mindestens 2 Zeichen lang sein' }
                ]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="Ihr vollständiger Name"
                  style={{ borderRadius: '8px' }}
                />
              </Form.Item>

              <Form.Item
                name="email"
                label="Deine E-Mail Adresse"
                rules={[
                  { required: true, message: 'Bitte geben Sie Ihre E-Mail ein' },
                  { type: 'email', message: 'Bitte geben Sie eine gültige E-Mail ein' }
                ]}
              >
                <Input 
                  prefix={<MailOutlined />} 
                  placeholder="ihre.email@beispiel.de"
                  style={{ borderRadius: '8px' }}
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  style={{
                    backgroundColor: '#2563eb',
                    borderColor: '#2563eb',
                    height: '48px',
                    fontSize: '16px',
                    fontWeight: 500,
                    borderRadius: '8px',
                    marginTop: '16px'
                  }}
                >
                  {loading ? 'Wird gesendet...' : 'Benachrichtigung erhalten'}
                </Button>
              </Form.Item>
            </Form>

            <div style={{ 
              textAlign: 'center', 
              marginTop: '24px',
              padding: '16px',
              backgroundColor: '#f8fafc',
              borderRadius: '8px'
            }}>
              <Text style={{ 
                fontSize: '12px', 
                color: '#64748b',
                lineHeight: '1.4'
              }}>
                Wir respektieren Ihre Privatsphäre. Ihre Daten werden nur für die 
                Benachrichtigung über den Launch verwendet und nicht an Dritte weitergegeben.
              </Text>
            </div>
          </div>
        </Col>
      </Row>
    </Modal>
  )
}

export default RegistrationModal
